import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function CollectionPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id, title } = location.state || {};

  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (!id) {
      navigate("/");
      return;
    }

    // Fetch products for this collection from backend
    fetch(`https://skpbackend-production.up.railway.app/collections/${id}/products`)
      .then((res) => res.json())
      .then((data) => setProducts(data || []))
      .catch((err) => console.error("Error fetching products:", err));
  }, [id, navigate]);

  if (!id) return null;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">{title}</h1>
      {products.length === 0 ? (
        <p>No products available in this collection.</p>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          {products.map((product) => (
            <div key={product.id} className="rounded-lg shadow-md overflow-hidden hover:shadow-xl transition">
              <img
                src={`https://skpbackend-production.up.railway.app/${product.image}`}
                alt={product.name}
                className="w-full h-40 object-cover"
              />
              <div className="p-3">
                <h3 className="font-semibold">{product.name}</h3>
                <p className="text-gray-600">₹{product.price}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
